import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../utils/config";

export default function Product() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${config.baseurl}/products/`);
      setProducts(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
useEffect(() => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });
}, []);
 return (
  <div className="relative min-h-screen overflow-hidden">

    <video
      autoPlay
      muted
      loop
      playsInline
      className="fixed top-0 left-0 w-full h-full object-cover -z-20"
    >
      <source src="/videos/bg.mp4" type="video/mp4" />
    </video>

    <div className="absolute inset-0 bg-black/40"></div>

    <div className="relative z-10 mt-2">

      {loading ? (
        <div className="text-center text-white text-2xl mt-32">
          Loading...
        </div>
      ) : products.length === 0 ? (
        <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
          <h1 className="text-5xl font-bold text-cyan-400 mb-6">
            No Products Available
          </h1>

          <p className="text-gray-300 text-xl max-w-2xl">
            There are no products available right now.
            We will upload our latest products soon.
            Please visit again later.
          </p>

          <button
            onClick={() => navigate("/contact")}
            className="mt-8 px-8 py-3 bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg font-semibold"
          >
            Contact Us
          </button>
        </div>
      ) : (
        <div>

          <div className="text-center mt-10 mb-16">
            <h1 className="text-5xl font-bold text-cyan-500">
              Our Products
            </h1>

            <p className="text-gray-300 mt-4 text-lg">
              Explore our latest software and IT solutions
            </p>
          </div>

          {products.map((product) => (
            <div key={product.id} className="max-w-7xl mx-auto px-6 mb-24">
              <div className="grid lg:grid-cols-2 gap-10 items-center">

                <div>
                  <h1 className="text-5xl font-bold text-cyan-500 mb-8">
                    {product.title}
                  </h1>

                  <p className="text-gray-300 text-lg leading-9 text-justify">
                    {product.description}
                  </p>

                  <button
                    onClick={() => navigate("/contact")}
                    className="mt-10 px-8 py-4 bg-cyan-500 hover:bg-cyan-600 text-white font-semibold rounded-lg transition"
                  >
                    KNOW MORE
                  </button>
                </div>

                {/* <div className="flex justify-center">
                  <img
                    src={product.image}
                    alt={product.title}
                     className="w-[600px] h-[500px] rounded-xl shadow-2xl object-cover"
                  />
                </div> */}
<div
  className="
    bg-cyan-500
    rounded-xl
    shadow-lg
    overflow-hidden
    w-full
    max-w-[500px]
    mx-auto
  "
>
  <div
    className="
      h-[250px]
      sm:h-[300px]
      md:h-[350px]
      lg:h-[400px]
      w-full
      bg-black/40
      flex
      items-center
      justify-center
      p-4
    "
  >
    <img
      src={product.image}
      alt={product.title}
      className="
        max-h-full
        max-w-full
        object-contain
      "
    />
  </div>

  <div className="p-5">
    <h3 className="text-xl font-bold text-white mb-3">
      {product.title}
    </h3>
  </div>
</div>
              </div>
            </div>
          ))}

        </div>
      )}

    </div>

    <div className="relative z-10 bg-black/70 backdrop-blur-md py-12">

      <div className="max-w-7xl mx-auto px-5">

        <div className="grid md:grid-cols-3 gap-10">

          <div>
            <h3 className="text-xl font-bold text-cyan-400 mb-3">
              Kerala Branch
            </h3>

            <p className="leading-7 text-white">
              1st Floor - JK Building<br />
              Kannur, Kannur 670684<br />
              Phone: +91 90000 90000
            </p>

            <h3 className="text-xl font-bold text-cyan-400 mt-6 mb-3">
              Tamil Nadu Branch
            </h3>

            <p className="leading-7 text-white">
              First Floor, D Block,<br />
              JK Park, Chennai<br />
              Tamil Nadu 600100<br />
              Phone: +91 70000 80000<br />
              Email: jk@gmail.com
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold text-cyan-400 mb-5">
              Quick Links
            </h3>

            <ul className="space-y-3 text-white">
              <li onClick={() => navigate("/home")} className="cursor-pointer">Home</li>
              <li onClick={() => navigate("/about")} className="cursor-pointer">About Us</li>
              <li onClick={() => navigate("/services")} className="cursor-pointer">Services</li>
              <li onClick={() => navigate("/product")} className="cursor-pointer">Products</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold text-cyan-400 mb-5">
              More Links
            </h3>

            <ul className="space-y-3 text-white">
              <li onClick={() => navigate("/careers")} className="cursor-pointer">Career</li>
              <li onClick={() => navigate("/events")} className="cursor-pointer">Events</li>
              <li onClick={() => navigate("/blogs")} className="cursor-pointer">Blogs</li>
            </ul>
          </div>

        </div>
      </div>
    </div>

  </div>
);
}